<template>
  <div class="!pt-3">
    <el-form>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="form-group">
            <el-form-item>
              <label
                class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
              >
                Content
              </label>
              <el-input
                type="textarea"
                autosize
                v-model="field.content"
                placeholder="Enter content"
                class="!my-1 w-full"
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'templates-formComponents-Paragraph',
    props: ['field'],
    data() {
      return {};
    },
    mounted() {},
  };
</script>

<style lang="scss"></style>
